/**
 * @generated SignedSource<<420798434449b02dbcd1f2f2e4db794c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type UJStatuses = "OBSOLETE" | "PAUSED" | "RUNNING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type Wallboard_bars$data = {
  readonly currentUser: {
    readonly isPowerUser: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"userJourneys_userPreferences">;
  };
  readonly currentUserDivisions: ReadonlyArray<{
    readonly divisionID: number;
    readonly name: string;
  }>;
  readonly localState: {
    readonly samples: ReadonlyArray<{
      readonly ujID: number;
      readonly " $fragmentSpreads": FragmentRefs<"Wallboard_userJourneySamples">;
    }> | null;
  } | null;
  readonly userJourneys: ReadonlyArray<{
    readonly status: UJStatuses;
    readonly ujID: number;
    readonly " $fragmentSpreads": FragmentRefs<"Wallboard_userJourneyRow">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"urlParams_thirdPartyToggleDefaults">;
  readonly " $fragmentType": "Wallboard_bars";
};
export type Wallboard_bars$key = {
  readonly " $data"?: Wallboard_bars$data;
  readonly " $fragmentSpreads": FragmentRefs<"Wallboard_bars">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ujID",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "backup"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Wallboard_bars",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPowerUser",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "userJourneys_userPreferences"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Division",
      "kind": "LinkedField",
      "name": "currentUserDivisions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "divisionID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserJourney",
      "kind": "LinkedField",
      "name": "userJourneys",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Wallboard_userJourneyRow"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "urlParams_thirdPartyToggleDefaults"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LocalState",
          "kind": "LinkedField",
          "name": "localState",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "backup",
                  "variableName": "backup"
                }
              ],
              "concreteType": "LocalSamples",
              "kind": "LinkedField",
              "name": "samples",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Wallboard_userJourneySamples"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "4590bd7934b7ba36be52c6d84850e761";

export default node;
